export const getPerformanceShimmerStyle = (_, { palette = {} }) => ({
  shimmerContainer: {
    margin: '16px 0',
  },
  shimmerStyle: {
    background: palette.white,
    borderRadius: '2px',
    marginTop: '14px',
    height: '15px',
  },
});
